import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { OriginalPrice as OriginalPriceTrans } from 'autogen/translation-keys/trans-website-product-screenreader';
import { Typography } from 'components/generic/typography';
import ScreenReaderOnly from 'components/ScreenReaderOnly';
import type { PriceModuleProps, Size } from './shared/types';

const DiscountContainer = styled.div`
    display: flex;
    gap: ${({ theme }) => theme.Spacing4};
`;

const OriginalPrice = styled(Typography.Body)`
    color: ${({ theme }) => theme.ColorTextSecondary};
`;

const SavingsPrice = styled(Typography.Body)`
    color: ${({ theme }) => theme.ColorTextSale};
`;

type PriceDiscountProps = {
    priceBefore: NonNullable<PriceModuleProps['priceBefore']>;
    saveLabel?: PriceModuleProps['saveLabel'];
    size: Size;
};

export function PriceDiscount({ priceBefore, saveLabel, size }: PriceDiscountProps) {
    const { t } = useTranslation();

    if (!!saveLabel && size === 'lg') {
        return (
            <DiscountContainer>
                <OriginalPrice size="M" forwardedAs="del">
                    <ScreenReaderOnly>{t(OriginalPriceTrans)}</ScreenReaderOnly>
                    {priceBefore}
                </OriginalPrice>
                <SavingsPrice size="M" forwardedAs="div">
                    {saveLabel}
                </SavingsPrice>
            </DiscountContainer>
        );
    }

    return (
        <OriginalPrice size={size === 'lg' ? 'M' : 'S'} forwardedAs="del">
            <ScreenReaderOnly>{t(OriginalPriceTrans)}</ScreenReaderOnly>
            {priceBefore}
        </OriginalPrice>
    );
}
